import { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Spin } from 'antd';

import WorkRecordStatComponent from '../../components/work-records/WorkRecordStatComponent';
import { getWorkRecordStat } from '../../api/constlink';

interface WorkRecordStatContainerProps {
  enterpriseId: string;
  projectId: string;
}

function WorkRecordStatContainer({
  history,
  match,
}: RouteComponentProps<WorkRecordStatContainerProps>) {
  const { enterpriseId, projectId } = match.params;
  const [data, setData] = useState<any>();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const res = await getWorkRecordStat({ enterpriseId, projectId });
      setData(res);
      setIsLoading(false);
    })();
  }, [enterpriseId, projectId]);

  return (
    <>
      {isLoading && <Spin />}
      {data && <WorkRecordStatComponent data={data} />}
    </>
  );
}

export default WorkRecordStatContainer;
